

<div class="cx">

  <p class="cx-summary">{{ totalConnections }} {{ totalConnections === 1 ? 'connection' : 'connections' }} to this record</p>

  <!-- shared avatar -->
  <ng-template #cxAvatar let-c let-tone="tone">
    <span class="cx-avatar" [ngClass]="'is-' + (tone || avatarTone(c.name))">
      <img *ngIf="c.imageUrl" src="{{c.imageUrl}}" alt="">
      <ng-container *ngIf="!c.imageUrl">{{ c.shortName }}</ng-container>
    </span>
  </ng-template>

  <!-- shared email / phone line -->
  <ng-template #cxContact let-c>
    <span class="cx-item__contact" *ngIf="c.email || c.phone">
      <span *ngIf="c.email" class="cx-item__meta"><mat-icon>mail_outline</mat-icon>{{ c.email }}</span>
      <span *ngIf="c.phone" class="cx-item__meta"><mat-icon>call</mat-icon>{{ formatPhone(c.phone) }}</span>
    </span>
  </ng-template>

  <!-- ===== Owner ===== -->
  <section class="cx-section" [class.is-collapsed]="collapsedSections.owner">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>person</mat-icon></span>
      <h3>Owner</h3>
      <span class="cx-count">{{ Owners.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" *ngIf="Owners.length == 0"
        (click)="addOwner(ownerAdd,false,false)" matTooltip="Add owner" matTooltipClass="tooltip" aria-label="Add owner">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('owner')"
        [attr.aria-expanded]="!collapsedSections.owner" aria-label="Toggle owner">
        <mat-icon>{{ collapsedSections.owner ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.owner">
      <div class="cx-item" *ngFor="let c of Owners">
        <button type="button" class="cx-item__main" (click)="contactDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'owner' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role">Record owner</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="ownerMenu" aria-label="Owner options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="contactDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #ownerMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="contactDetail(c)"><mat-icon>open_in_new</mat-icon> Open details</button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedContact(c.coreID,c.contactID,c.coreContactUserMapID)">
            <mat-icon>person_remove</mat-icon> Remove owner
          </button>
        </mat-menu>
      </div>
      <p class="cx-empty" *ngIf="Owners.length == 0">No owner yet.</p>
    </div>
  </section>

  <!-- ===== Associated records (residents) ===== -->
  <section class="cx-section" [class.is-collapsed]="collapsedSections.core">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>people</mat-icon></span>
      <h3>Associated {{ CoreName }}</h3>
      <span class="cx-count">{{ NormalCore.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" (click)="addcore(coreAdd)"
        matTooltip="Add {{ CoreName }}" matTooltipClass="tooltip" [attr.aria-label]="'Add ' + CoreName">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('core')"
        [attr.aria-expanded]="!collapsedSections.core" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.core ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.core">
      <div class="cx-item" *ngFor="let c of NormalCore">
        <button type="button" class="cx-item__main" (click)="coreDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'blue' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="coreMenu" aria-label="Options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="coreDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #coreMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="coreDetail(c)"><mat-icon>open_in_new</mat-icon> Open record</button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedCore(c)"><mat-icon>link_off</mat-icon> Remove link</button>
        </mat-menu>
      </div>
      <p class="cx-empty" *ngIf="NormalCore.length == 0">No {{ CoreName }} linked yet.</p>
    </div>
  </section>

  <!-- ===== Contacts ===== -->
  <section class="cx-section" [class.is-collapsed]="collapsedSections.contacts">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>contacts</mat-icon></span>
      <h3>{{ ContactName }}</h3>
      <span class="cx-count">{{ NormalContacts.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" (click)="addShare(shareAdd,false,false,'')"
        matTooltip="Add {{ ContactName }}" matTooltipClass="tooltip" [attr.aria-label]="'Add ' + ContactName">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('contacts')"
        [attr.aria-expanded]="!collapsedSections.contacts" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.contacts ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.contacts">
      <div class="cx-item" *ngFor="let c of NormalContacts">
        <button type="button" class="cx-item__main" (click)="contactDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'violet' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role" *ngIf="c.contactCoreRoleMappingModels?.length">{{ relationText(c.contactCoreRoleMappingModels) }}</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>

        <span class="cx-item__aside">
          <span class="cx-dot" [class.is-on]="c.isPortalAccess"
            [matTooltip]="c.isPortalAccess ? 'Has portal access' : 'No portal access'" matTooltipClass="tooltip"></span>
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="contactMenu" aria-label="Contact options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="contactDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #contactMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="contactDetail(c)"><mat-icon>open_in_new</mat-icon> Open details</button>
          <button mat-menu-item (click)="togglePortalAccess(c)">
            <mat-icon>{{ c.isPortalAccess ? 'lock' : 'lock_open' }}</mat-icon>
            {{ c.isPortalAccess ? 'Revoke portal access' : 'Give portal access' }}
          </button>
          <button mat-menu-item (click)="addShare(RoleAddEdit,false,true,c)"><mat-icon>label</mat-icon> Add relation</button>
          <button mat-menu-item *ngFor="let transRole of c.contactCoreRoleMappingModels"
            (click)="deleteRole(transRole.coreContactRoleID,$event)">
            <mat-icon>label_off</mat-icon> Remove "{{ transRole.rloeName }}"
          </button>
          <button mat-menu-item *ngIf="PCCPatientIDShow==true" (click)="CreatePendingContactPCC(c)">
            <img class="cx-menu-img" src="https://developer.pointclickcare.com/assets/app/favicon.png" alt=""> Send to PointClickCare
          </button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedContact(c.coreID,c.contactID,c.coreContactUserMapID)">
            <mat-icon>person_remove</mat-icon> Remove
          </button>
        </mat-menu>
      </div>
      <p class="cx-empty" *ngIf="NormalContacts.length == 0">No {{ ContactName }} added yet.</p>
    </div>
  </section>

  <!-- ===== Shared access ===== -->
  <section class="cx-section" [class.is-collapsed]="collapsedSections.shared">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>vpn_key</mat-icon></span>
      <h3>Shared access</h3>
      <span class="cx-count">{{ SharedContacts.length + SharedRoleList.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" (click)="addShare(shareAdd,true,false,'')"
        matTooltip="Share access" matTooltipClass="tooltip" aria-label="Share access">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('shared')"
        [attr.aria-expanded]="!collapsedSections.shared" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.shared ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.shared">
      <div class="cx-item" *ngFor="let c of SharedContacts">
        <button type="button" class="cx-item__main" (click)="contactDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'green' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role" *ngIf="c.contactCoreRoleMappingModels?.length">{{ relationText(c.contactCoreRoleMappingModels) }}</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="sharedMenu" aria-label="Options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="contactDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #sharedMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="contactDetail(c)"><mat-icon>open_in_new</mat-icon> Open details</button>
          <button mat-menu-item (click)="addShare(RoleAddEdit,true,true,c)"><mat-icon>label</mat-icon> Add relation</button>
          <button mat-menu-item *ngFor="let transRole of c.contactCoreRoleMappingModels"
            (click)="deleteRole(transRole.coreContactRoleID,$event)">
            <mat-icon>label_off</mat-icon> Remove "{{ transRole.rloeName }}"
          </button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedContact(c.coreID,c.contactID,c.coreContactUserMapID)">
            <mat-icon>person_remove</mat-icon> Remove access
          </button>
        </mat-menu>
      </div>

      <!-- roles with access -->
      <div class="cx-item is-static" *ngFor="let c of SharedRoleList">
        <div class="cx-item__main">
          <span class="cx-avatar is-role"><mat-icon>groups</mat-icon></span>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role">Role</span>
          </span>
        </div>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" (click)="deleteSelectedContact(c.coreID,c.contactID,c.coreContactUserMapID)"
            matTooltip="Remove access" matTooltipClass="tooltip" aria-label="Remove access">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </div>

      <p class="cx-empty" *ngIf="SharedContacts.length == 0 && SharedRoleList.length == 0">Not shared with anyone yet.</p>
    </div>
  </section>

  <!-- ===== Organizations ===== -->
  <section class="cx-section" [class.is-collapsed]="collapsedSections.companies">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>apartment</mat-icon></span>
      <h3>{{ CompanyName }}</h3>
      <span class="cx-count">{{ NormalCompanys.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" (click)="addShare(CompanyAddEdit,false,false,'')"
        matTooltip="Add {{ CompanyName }}" matTooltipClass="tooltip" [attr.aria-label]="'Add ' + CompanyName">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('companies')"
        [attr.aria-expanded]="!collapsedSections.companies" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.companies ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.companies">
      <div class="cx-item" *ngFor="let c of NormalCompanys">
        <button type="button" class="cx-item__main" (click)="companyDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'amber' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role" *ngIf="c.companyCoreRoleMappingModels?.length">{{ relationText(c.companyCoreRoleMappingModels) }}</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="companyMenu" aria-label="Options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="companyDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #companyMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="companyDetail(c)"><mat-icon>open_in_new</mat-icon> Open details</button>
          <button mat-menu-item (click)="addShareCompany(RoleAddEditCompany,false,true,c)"><mat-icon>label</mat-icon> Add relation</button>
          <button mat-menu-item *ngFor="let transRole of c.companyCoreRoleMappingModels"
            (click)="deleteCompanyRole(transRole.coreCompanyRoleID,$event)">
            <mat-icon>label_off</mat-icon> Remove "{{ transRole.rloeName }}"
          </button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedCompany(c.coreID,c.companyID,c.companyCoreUserMapID)">
            <mat-icon>link_off</mat-icon> Remove
          </button>
        </mat-menu>
      </div>
      <p class="cx-empty" *ngIf="NormalCompanys.length == 0">No {{ CompanyName }} linked yet.</p>
    </div>
  </section>

</div>


<ng-template #shareAdd>

    <h2 mat-dialog-title *ngIf="isShare">
       <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
          Add {{ContactName}} / User / Role
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>

        <h2 mat-dialog-title *ngIf="!isShare">
            <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
             Add {{ContactName}}
               <button mat-icon-button (click)="close()">
                 <mat-icon>close</mat-icon>
               </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">
    

    <div class="radOpts" *ngIf="isShare">

        <mat-radio-group aria-label="Select an option" color="primary">
            <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">{{ContactName}}</mat-radio-button>
            <mat-radio-button value="3" (click)="selectSharedAccessRb(3)">User</mat-radio-button>
            <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
           
          </mat-radio-group>

    </div>

    <app-contactlist *ngIf="!isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="contactsList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="contactSelected($event)" (NotifyListfetch)="getContactListCoreImplementation($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="sharedAccessRoleList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>

    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeItem(user,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
            <div class="detail">
                <h4> {{role.name}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeItemRoleSharedAccess(role,isSharedAccessRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="isSharedAccessUserPopup ==true" class="selectedlist">
      <li *ngFor="let user of userSelectedList">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCoreContact()">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #ownerAdd>

  <h2 mat-dialog-title>
     <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Add Owner 
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
   </h2>     
  
<mat-dialog-content class="mat-typography">  
  
  <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>

  <ul *ngIf="isSharedAccessUserPopup ==true" class="selectedlist">
    <li *ngFor="let user of userSelectedList">
      <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
                {{user.shortName}}
              </span>
          </div>
          <div class="detail">
              <h4>{{user.name}}</h4>
              <p>{{user.email}}</p>
          </div>
          <div class="opt">
              <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
          </div>
      </div>
    </li>
  </ul>

</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCoreContact()">Done</button>
</mat-dialog-actions>
</ng-template>


  <ng-template #RoleAddEdit>
    <h2 mat-dialog-title>
       <span  class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Add Relation to {{currentRoleContact.name}}
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
  <mat-dialog-content class="mat-typography">    

    <app-contactlist [objectList]="transRoleList" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelected($event)"  (NotifyListfetch)="getTransactinalRoles($event)"></app-contactlist>
    
    <ul class="selectedlist">      
      <li *ngFor="let role of Roles">
        <div class="userndetail">            
            <div class="detail">
                <h4> {{role.transactionalRoleName}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeItem(role,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showContactRoleAddButton (click)="addUpdateCoreContactRole()">Done</button>
  </mat-dialog-actions>
  </ng-template>


  <ng-template #RoleAddEditCompany>
    <h2 mat-dialog-title>
       <span  class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Add Relation to {{currentRoleContact.name}}
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
  <mat-dialog-content class="mat-typography">    

    <app-contactlist [objectList]="transRoleList" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelectedForCompany($event)"  (NotifyListfetch)="getTransactinalRoles($event)"></app-contactlist>
    
    <ul class="selectedlist">
      <li *ngFor="let role of RolesCompany">
        <div class="userndetail">            
            <div class="detail">
                <h4> {{role.transactionalRoleName}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeItemRoleCompany(role,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showCompanyRoleAddButton (click)="addUpdateCoreCompanyRole()">Done</button>
  </mat-dialog-actions>
  </ng-template>

  <ng-template #CompanyAddEdit>
        <h2 mat-dialog-title *ngIf="!isShare">
            <span  class="groupIcon" ><mat-icon>group_add</mat-icon></span>
             Add {{CompanyName}}
               <button mat-icon-button (click)="close()">
                 <mat-icon>close</mat-icon>
               </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">
    
 <app-contactlist [objectList]="companysList" [isCompanyPopup]="true"  (NotifyItemSelected)="companySelected($event)" (NotifyListfetch)="getCompanyListCoreImplementation($event)" ></app-contactlist>
  
  
    <ul class="selectedlist">      
      <li *ngFor="let user of selectedcompanyList">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeItemCompany(user,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>

    </ul>
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCoreCompany()">Done</button>
  </mat-dialog-actions>
  </ng-template>


<ng-template #coreAdd>

  <h2 mat-dialog-title>
     <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Add {{CoreName}} 
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
   </h2>     
  
<mat-dialog-content class="mat-typography">  
  
  <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
        <mat-label>Search {{CoreName}}</mat-label>
        <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
          (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="coreSelectedNew(core)" *ngFor="let core of attachedToCoreList"
            [value]="core.name">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="userpic">
                <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                <span class="username" *ngIf="core.imageUrl==''" class="username">
                  {{core.shortName}}
                </span>
              </div>
              <div class="info">
                <p> {{ core.name }}</p>
                <p class="email">{{ core.email }}</p>
              </div>
            </span>
          </mat-option>
        </mat-autocomplete>

  </mat-form-field>

   <ul class="selectedlist">
      <li *ngFor="let ass of addUpdateParticipantList">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="ass.img!=''" src="{{ass.img}}" alt="">
            <span *ngIf="ass.img==''" class="username">
              {{ass.shortName}}
            </span>
          </div>
          <div class="details">
            <h4>{{ass.name}}</h4>
            <p>{{ass.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button matTooltip="Remove">
              <mat-icon (click)="removeParticipant(ass)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCoreToCore()">Done</button>
</mat-dialog-actions>
</ng-template>


  <app-addnew  *ngIf="showAddContact" (closeAdd)="getClose($event)" [name]="searchName" (contactSaved)="getNormalAndSharedContacts()"
  (companySaved)="getNormalAndSharedCompanys()"  [coreID]="coreID" 
  [isShared]="isShare" [mainModuleName]='mainModuleName' [modulename]='Module' [ngClass]="{'open': showAddContact}" >
  </app-addnew>

  <app-details *ngIf="showDetail" [ngClass]="{ open: showDetail }" [transactionID]='TransactionId' [modulenames]='Module' 
  (closeDetail)="getCloseDetails($event)">
  </app-details>
